import axios from '@/libs/axios'
const url =  'https://api.pagwise.com/'  // "https://api.pagwise.com/" //http://localhost:3000/
export default {
  namespaced: true,
  actions: {

   async Logar(context, credentials) {
      
      return new Promise((resolve, reject) => {
              
                return axios.post(url + "api/v1/auth/login", credentials)
                  .then(({ data }) => {
                       console.log(data)
                        context.commit('SET_USER', data.data.user)

                        resolve(data);
                    })
                    .catch(error => {
                        // context.commit(SET_ERROR, error.response);
                        reject(error)
                    });
            });


    },

  },
  mutations: {

    SET_AUTH(state, dados) {

      state.isAuthenticated = dados;

    },
    SET_USER(state, dados) {

      state.usuario = dados;

    },

  },

  state: {
    isAuthenticated:true,
    usuario:{
      name:"Joao",
      companyId:"000",
      email:"email@email.com"
    }
  }
}


